/**
 * Checks if the workplace type is "Home Healthcare" or "Hospice".
 * These workplace types have a reduced UI in the Workplace Profile Modal.
 */
export function isHomeHealthOrHospiceWorkplace(type: string | undefined): boolean {
  return type === "Home Healthcare" || type === "Hospice";
}
